import React, { useState, useEffect, useRef, useCallback } from 'react';
import style from './BodyMassRecord.module.css';
import HeadSub from '../../../../../components/comm/HeadSub';
import Modal from '../../../../../components/comm/Modal';
import ToastPopup from '../../../../../components/comm/ToastPopup';
import noDataImg from '../../../../../images/common/i_3d_no_data_doc.svg';
import URL from '../../../../../constants/url';
import BodyMassRecordBox from '../../../../../components/box/BodyMassRecordBox';
import LineGraphBox from '../../../../../components/box/LineGraphBox';

import { useNavigate, useLocation  } from 'react-router-dom';

import axiosApi from '../../../../../api/daonAxios';
import CODE from '../../../../../constants/code';

import Skeleton from '@mui/material/Skeleton';


const BodyMassRecord = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const [recordList, setRecordList] = useState([]);
    const [bmiList, setBmiList] = useState([]);  //bmi
    const [graphRecords, setGraphRecords] = useState([]);  // 그래프 상태 

    const [isOpen, setIsOpen] = useState(false);    //모달창
    const [deleteIndex, setDeleteIndex] = useState(null);
    const [toast, setToast] = useState(false); //토스트 팝업
    const [toastMessage, setToastMessage] = useState('');

    const [visibleCount, setVisibleCount] = useState(10); // 리스트 갯수
    const [isLoading, setIsLoading] = useState(false); // 스크롤 딜레이 중인지

    const [isInitialLoading, setIsInitialLoading] = useState(true); // 초기 로딩 상태


    const confirmDelete = (index) => {
        setDeleteIndex(index);
        setIsOpen(true);
    };

    const handleConfirmDelete = () => {
        if (deleteIndex !== null) {
            handleDelete(deleteIndex);
            setDeleteIndex(null);
        }
        setIsOpen(false);
    };

    //날짜 변환
    const parseDateTime = (dateStr, timeStr) => {
        // 예: dateStr = "20250703", timeStr = "100700"
        const year = parseInt(dateStr.substring(0, 4), 10);
        const month = parseInt(dateStr.substring(4, 6), 10) - 1; // 0-based
        const day = parseInt(dateStr.substring(6, 8), 10);

        const hour = parseInt(timeStr.substring(0, 2), 10);
        const minute = parseInt(timeStr.substring(2, 4), 10);
        const second = parseInt(timeStr.substring(4, 6), 10);

        return new Date(year, month, day, hour, minute, second);
    };

    //데이터 최신순 정렬
    const updateList = (records) => {
        const sortedByLatest = [...records].sort((a, b) => {
            const dateA = parseDateTime(a.recDe, a.recTm);
            const dateB = parseDateTime(b.recDe, b.recTm);
            return dateB - dateA;
        });
        setRecordList(sortedByLatest);
    }

    //그래프 전용 데이터
    const updateGraphData = (records) => {
        if (!records || records.length === 0) return;

        // 최신순 정렬
        const sortedByLatest = [...records].sort((a, b) => {
            const dateA = parseDateTime(a.recDe, a.recTm);
            const dateB = parseDateTime(b.recDe, b.recTm);
            return dateB - dateA;
        });

        const latestThree = sortedByLatest.slice(0, 3);

        // 오름차순 정렬
        const sortedAsc = [...latestThree].sort((a, b) => {
            const dateA = parseDateTime(a.recDe, a.recTm);
            const dateB = parseDateTime(b.recDe, b.recTm);
            return dateA - dateB;
        });

        setBmiList(sortedAsc.map(r => r.bmi));
        setGraphRecords(sortedAsc.map(r => ({
            ...r,
            date: formatDateStr(r.recDe),
            time: convertTimeStr(r.recTm),
        })));
    };


    //삭제
    const handleDelete = (index) => {
        setUsrBmiHist(index);
    };
    const setUsrBmiHist = useCallback(async (index) => {
        const record = recordList[index];
        if (!record || !record.usrBmiHistId) return;

        const url = "/homecare/bmi/deleteBodyMassRecordHistory";
        const jToken = localStorage.getItem('jToken');

        const reqOptions = {
            headers: {
                Authorization: jToken,
            }
        };

        const reqBody = {
            usrBmiHistId: record.usrBmiHistId
        };

        try {
            const res = await axiosApi.post(url, reqBody, reqOptions);
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                setToastMessage('기록이 삭제되었습니다.');
                setToast(true); // 삭제 후 토스트
                getUsrBmiHist(); // 리스트 새로고침
            } else {
                alert(res.data.resultMessage);
            }
        } catch (err) {
            console.error("체질량 기록 삭제 중 오류: ", err);
        }
    }, [recordList, navigate]);

    //시간 변환 (시간, 날짜)
    const convertTimeStr = (timeStr) => {
        const hour = timeStr.substring(0, 2);
        const minute = timeStr.substring(2, 4);
        return `${hour}:${minute}`;
    };
    const formatDateStr = (dateStr) => {
        if (!dateStr || dateStr.length !== 8) return dateStr;
        const year = dateStr.substring(2, 4);  // 2025 -> 25
        const month = dateStr.substring(4, 6);
        const day = dateStr.substring(6, 8);
        return `${year}.${month}.${day}`;
    };

    // 최신 날짜용 (연도 4자리)
    const formatLatestDateStr = (dateStr) => {
        if (!dateStr || dateStr.length !== 8) return dateStr;
        const year = dateStr.substring(0, 4);  // 25 -> 2025
        const month = dateStr.substring(4, 6);
        const day = dateStr.substring(6, 8);
        return `${year}.${month}.${day}`;
    };

    //데이터 불러오기
    const isFirstRender = useRef(true);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            getUsrBmiHist();
            return;
        }
    }, []);

    const getUsrBmiHist = useCallback(async () => {
        const url = "/homecare/bmi/retrieveBodyMassRecordHistory";

        const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));

        const jToken = localStorage.getItem('jToken');
        const reqOptions = {
            headers: {
                Authorization: jToken,
            }
        };
        console.log("========> usrInfoId: ", loginUser.usrInfoId);
        const reqBody = {
            usrInfoId: loginUser.usrInfoId
        };
        try {
            const res = await axiosApi.post(url, reqBody, reqOptions);
            console.log(res);
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                const recList = res.data.result.recList;

                setRecordList(recList);
                updateGraphData(recList); //그래프 업데이트
                updateList(recList); //리스트 업데이트
            } else {
                alert(res.data.resultMessage);
            }
        } catch (err) {
            console.error("체질량 기록 조회 중 오류: ", err);
        } finally {
            setIsInitialLoading(false); // 로딩 완료
        }

    }, [navigate,recordList]);

    useEffect(() => {
        if (location.state?.showToast) {
        setToastMessage(location.state.toastMessage);
        setToast(true);
        
        // 토스트 띄운 후에 state 초기화 (덮어쓰기)
        navigate(location.pathname, { replace: true, state: {} });
        }
    }, [location.state, location.pathname, navigate]);

    //뒤로 가기
    const handleBack = () => {
        navigate(URL.HOME_CARE_MAIN, { 
            replace: true,
            state: { tabIndex: 1 } 
        });        
    };


    const loadMore = () => {
        if (isLoading) return; // 이미 로딩 중이면 무시
        setIsLoading(true);

        setTimeout(() => {
            setVisibleCount(prev => Math.min(prev + 10, recordList.length));
            setIsLoading(false);
        }, 300); // 300ms 딜레이
    };

    //무한 스크롤
    const observerRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    loadMore();
                }
            },
            { threshold: 1 }
        );

        if (observerRef.current) {
            observer.observe(observerRef.current);
        }

        return () => {
            if (observerRef.current) {
                observer.unobserve(observerRef.current);
            }
        };
    }, [recordList, visibleCount]);

    // 스켈레톤 컴포넌트
    const SkeletonLoader = () => (
        <>
            {/* 그래프 스켈레톤 */}
            <div className={style['graph-box']}>
                <div className={style['graph-top']}>
                    <Skeleton variant="text" width={150} height={24} />
                    <Skeleton variant="text" width={80} height={24} />
                </div>
                <div className={style['graph-bot']}>
                    <div className={style['inner-box']}>
                        <Skeleton variant="rectangular" width="100%" height={110} style={{borderRadius:'12px'}} />
                    </div>
                </div>
            </div>

            {/* 리스트 스켈레톤 */}
            <div className="inner-wrap">
                <div className={style['record-box-lists']}>
                    <ul>
                        {[...Array(3)].map((_, idx) => (
                            <li key={idx} style={{ width:"100%", height:'120px', padding:'16px', marginBottom: '12px', backgroundColor:'#fff', borderRadius:'12px'}}>
                                 <Skeleton variant="text" width={80} height={24} style={{ borderRadius:'4px', marginBottom:'2px'}} />
                                 <Skeleton variant="text" width={'80%'} height={20} style={{ borderRadius:'4px', marginBottom:'2px'}} />
                                 <Skeleton variant="text" width={'60%'} height={20} style={{ borderRadius:'4px', marginBottom:'2px'}} />
                                 <Skeleton variant="text" width={120} height={22} style={{ borderRadius:'4px', marginBottom:'6px'}} />
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </>
    );


    return (
        <>
            
            <HeadSub title="체질량 기록" rightBtn="yes" rightTitle="체질량 가이드" recordNum="2" onBack={handleBack} tabIndex={1}/>  {/* recordNum="1" 혈압 , 2 = 체질량 , 3 = 혈당 */}
             

            <div id="sub-content" tabIndex={-1}>

            {isInitialLoading ? (
                <SkeletonLoader />
            ) : recordList.length === 0 ? (
                <div className='animation-3'>
                    <div className={style['no-data-box']}>
                        <div className={style['img-box']}>
                            <object data={noDataImg} aria-hidden='true'></object>        
                        </div>
                        <p>기록이 없습니다.</p>
                    </div>
                </div>
            ):
                <>      
                    <div className={style['graph-box']}>
                        <div className={style['graph-top']}>
                            <p>
                            {recordList.length > 0 
                                ? `${formatLatestDateStr(recordList[0].recDe)} ${convertTimeStr(recordList[0].recTm)}` 
                                : ''}
                            </p>
                            <ul className={style['legend-box']}>
                                <li data-status="2">
                                    <p>BMI</p>    
                                    <span>{bmiList.length > 0 ? bmiList[bmiList.length - 1] : ''}</span>
                                </li> 
                            </ul>
                        </div>
                        <div className={style['graph-bot']}>
                            <div className={style['inner-box']}>
                                <ul className={style['line-graph-box']}>
                                    <li>
                                        <LineGraphBox
                                            data={{
                                                columns: [bmiList]
                                            }}
                                            graphColor={[
                                            "#3284FF"
                                            ]}   
                                            height={10}
                                        />
                                    </li>
                                
                                </ul>

                                <div className={style['line-graph-date-box']}>
                                    <ul data-graph-length={recordList.length === 2 ? "twin" : ""}>  
                                        {graphRecords.map((item, idx) => (
                                            <li key={idx}>
                                                <div className={style['date-text']}>
                                                    <p>{formatDateStr(item.recDe)}</p>
                                                    <span>{convertTimeStr(item.recTm)}</span>
                                                </div>  
                                            </li>
                                        ))}
                                    </ul>
                                </div>

                            </div>
                        </div>
                    </div>    

                    <div className="inner-wrap">
                        <div className={style['record-box-lists']}>
                            <ul>
                                {recordList.slice(0, visibleCount).map((item, idx) => (
                                    <li key={idx}>
                                        <BodyMassRecordBox
                                            stature={item.height}
                                            weight={item.bdwgh}
                                            bmi={item.bmi}
                                            date={formatDateStr(item.recDe)}
                                            time={convertTimeStr(item.recTm)}
                                            onDelete={() => confirmDelete(idx)}
                                        />
                                    </li>
                                ))}
                            </ul>
                            {visibleCount < recordList.length && (
                                <div ref={observerRef} style={{ height: '1px' }} />
                            )}
                        </div>
                    </div>
                
                </> 
            }   


            {/* 하단 다음 버튼 영역 :: S */}
                <div className="bottom-fixed-box">
                        <div className="inner-box" data-bg-color="transparent">

                                {/* 버튼이 1개일때     */}
                            <div className='btn-layout' data-btn-num="1"> 
                                <button className="btn" data-btn-type="fill-main" data-btn-size="lg" onClick={()=> navigate(URL.BODY_MASS_WRITE)}>
                                    <span>체질량 기록하기</span>
                                </button>
                            </div>
                            
                        </div>
                </div>               
            {/* 하단 다음 버튼 영역 :: E */}  

            </div>

            <Modal isOpen={isOpen} setIsOpen={setIsOpen} >
                <div className='modal-box' data-type="a">
                    <div className='modal-top-box'>
                        <div className='title-box'>
                            <p>기록을 삭제하시겠어요?</p>
                        </div>
                    </div>

                    <div className="modal-bottom-box"> 
                        <div className='btn-layout'>
                            <button className="btn" data-btn-type="fill-gray" data-btn-size="md" onClick={()=>setIsOpen(false)}>
                                <span>아니요</span>
                            </button>
                            <button className="btn" data-btn-type="fill-main" data-btn-size="md" onClick={handleConfirmDelete}>
                                <span>네</span>
                            </button>
                            
                        </div>
                    </div>
                </div>
            </Modal>    

            {toast && (
                <ToastPopup
                    setToast={setToast}
                    message={toastMessage}
                    position="center"
                    opacity="90"
                />
            )} 

        </>
    );



};

export default BodyMassRecord;
